export default {
  'pwa.offline': 'You are offline now',
  'pwa.serviceworker.updated': 'New content is available',
  'pwa.serviceworker.updated.hint': 'Please press the "Refresh" button to reload current page',
  'pwa.serviceworker.updated.ok': 'Refresh',
};
